import { render, staticRenderFns } from "./ProductPrivacy.vue?vue&type=template&id=481afb06&scoped=true&"
import script from "./ProductPrivacy.vue?vue&type=script&lang=js&"
export * from "./ProductPrivacy.vue?vue&type=script&lang=js&"
import style0 from "./ProductPrivacy.vue?vue&type=style&index=0&id=481afb06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "481afb06",
  null
  
)

export default component.exports